var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.otolierData
        ? _c(
            "div",
            { staticClass: "top" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "hello" }, [
                _c(
                  "div",
                  { staticClass: "top--search-box" },
                  [_c("search-box")],
                  1
                ),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    src:
                      "https://eys-file.s3-ap-northeast-1.amazonaws.com/community/dummy/image/top/HELLO.svg",
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "head-image" }, [
                _c("img", {
                  attrs: { src: _vm.otolierData.top_space.head.icon, alt: "" }
                }),
                _vm._v(" "),
                _c("label", [
                  _vm._v(_vm._s(_vm.otolierData.top_space.head.status))
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.officialMembers, function(m, i) {
                return _c("official-member", {
                  key: m.name,
                  attrs: { member: m, id: "official-member-" + i },
                  on: { "action-button-click": _vm.showMaestroModal }
                })
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "center-info" },
                [
                  _c("img", {
                    attrs: {
                      src:
                        "https://eys-file.s3-ap-northeast-1.amazonaws.com/community/dummy/image/top/center_logo.svg",
                      alt: "Your 2nd Community"
                    }
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _c("user-relation-image", {
                    staticClass: "center-panel-image"
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("img", {
                staticClass: "chat-support",
                attrs: {
                  src:
                    "https://eys-file.s3-ap-northeast-1.amazonaws.com/community/dummy/image/top/chat-support%402x.png",
                  alt: "チャットサポート"
                }
              }),
              _vm._v(" "),
              _c(
                "a",
                { staticClass: "return-to-top", on: { click: _vm.gotoHome } },
                [
                  _c("img", {
                    attrs: {
                      src:
                        "https://eys-file.s3-ap-northeast-1.amazonaws.com/community/dummy/image/otolier/return-to-top@2x.png",
                      alt: "2nd Community TOP"
                    }
                  })
                ]
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "contents" }, [
        _c("div", { staticClass: "tags" }, [
          _c(
            "div",
            { staticClass: "tag-group" },
            [
              _c("span", { staticClass: "tag-group--title" }, [
                _vm._v("コミュニティ")
              ]),
              _vm._v(" "),
              _c("tag-label", { attrs: { label: "すべて", selected: "" } }),
              _vm._v(" "),
              _c("tag-label", { attrs: { label: "自分宛" } }),
              _vm._v(" "),
              _c("tag-label", { attrs: { label: "所属教室" } }),
              _vm._v(" "),
              _c("tag-label", { attrs: { label: "所属バンド" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tag-group" },
            [
              _c("span", { staticClass: "tag-group--title" }, [_vm._v("関連")]),
              _vm._v(" "),
              _c("tag-label", { attrs: { label: "すべて", selected: "" } }),
              _vm._v(" "),
              _c("tag-label", { attrs: { label: "友達" } }),
              _vm._v(" "),
              _c("tag-label", { attrs: { label: "講師" } }),
              _vm._v(" "),
              _c("tag-label", { attrs: { label: "スタッフ" } }),
              _vm._v(" "),
              _c("tag-label", { attrs: { label: "Otolier" } }),
              _vm._v(" "),
              _c("tag-label", { attrs: { label: "知り合い" } })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.timelineData
          ? _c("div", { staticClass: "timeline" }, [
              _c(
                "div",
                { staticClass: "timeline--card-container" },
                _vm._l(_vm.timeline1, function(p, i) {
                  return _c("timeline-card", {
                    key: i,
                    staticClass: "timeline--card",
                    attrs: { post: p }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "timeline--card-container" },
                _vm._l(_vm.timeline2, function(p, i) {
                  return _c("timeline-card", {
                    key: i,
                    staticClass: "timeline--card",
                    attrs: { post: p }
                  })
                }),
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.maestroModalVisible && _vm.otolierData
        ? _c("maestro-modal", {
            staticClass: "maestro-popup",
            attrs: { maestro: _vm.otolierData.details.fernando },
            on: { "close-button-click": _vm.closeMaestroModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("img", {
        attrs: {
          src:
            "https://eys-file.s3-ap-northeast-1.amazonaws.com/community/dummy/image/top/header@2x.png",
          alt: "ヘッダー"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "members-abstract" }, [
      _c("span", { staticClass: "member-count" }, [_vm._v("16")]),
      _vm._v("人のMember、"),
      _c("span", { staticClass: "member-count" }, [_vm._v("7")]),
      _vm._v("人のInstructorがいます\n      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center-info--buttons" }, [
      _c("button", { staticClass: "center-info--button" }, [
        _vm._v("\n          友達一覧\n          "),
        _c("span", { staticClass: "center-info--button-badge friends" }, [
          _vm._v("16")
        ])
      ]),
      _vm._v(" "),
      _c("button", { staticClass: "center-info--button" }, [
        _vm._v("\n          所有チケット一覧\n          "),
        _c("span", { staticClass: "center-info--button-badge tickets" }, [
          _vm._v("16")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }